// Step configuration for the signup wizard
// To add/modify steps: update this array and create corresponding step components

export const SIGNUP_STEPS = [
  {
    key: 'organization',
    label: 'Organization',
    stepNumber: 1,
    validate: (formData) => {
      const errors = {};
      if (!formData.organizationName?.trim()) {
        errors.organizationName = 'Organization name is required';
      }
      if (!formData.organizationAddress1?.trim()) {
        errors.organizationAddress1 = 'Address is required';
      }
      if (!formData.organizationCity?.trim()) {
        errors.organizationCity = 'City is required';
      }
      if (!formData.organizationState?.trim()) {
        errors.organizationState = 'State is required';
      }
      if (!formData.organizationZip?.trim()) {
        errors.organizationZip = 'ZIP code is required';
      }
      if (!formData.organizationCountry) {
        errors.organizationCountry = 'Country is required';
      }
      if (!formData.regionId) {
        errors.regionId = 'Region is required';
      }
      return { isValid: Object.keys(errors).length === 0, errors };
    }
  },
  {
    key: 'contactInfo',
    label: 'Contact',
    stepNumber: 2,
    validate: (formData) => {
      const errors = {};
      if (!formData.userFirstName?.trim()) {
        errors.userFirstName = 'First name is required';
      }
      if (!formData.userLastName?.trim()) {
        errors.userLastName = 'Last name is required';
      }
      if (!formData.userDomain?.trim()) {
        errors.userDomain = 'Domain is required';
      } else if (
        !/^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/.test(
          formData.userDomain.trim()
        )
      ) {
        errors.userDomain = 'Enter a valid domain (e.g. company.com)';
      }
      if (!formData.userEmail?.trim()) {
        errors.userEmail = 'Email is required';
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.userEmail)) {
        errors.userEmail = 'Please enter a valid email address';
      }
      if (!formData.organizationContactNo1?.trim()) {
        errors.organizationContactNo1 = 'Phone number is required';
      }
      return { isValid: Object.keys(errors).length === 0, errors };
    }
  },
  {
    key: 'industryDetails',
    label: 'Industry',
    stepNumber: 3,
    validate: (formData) => {
      const errors = {};
      if (!formData.verticalId) {
        errors.verticalId = 'Vertical is required';
      }
      if (!formData.subVerticalId) {
        errors.subVerticalId = 'Sub-vertical is required';
      }
      return { isValid: Object.keys(errors).length === 0, errors };
    }
  },
  {
    key: 'teamSetup',
    label: 'Team',
    stepNumber: 4,
    validate: (formData) => {
      const rows  = formData.teamInvites || [];
      const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const seen  = new Set();
      const errors = {};
      rows.forEach((r, i) => {
        if (!r.email?.trim()) return; // blank rows silently ignored
        if (!emailRe.test(r.email.trim()))
          errors[`teamInvites[${i}]`] = { ...(errors[`teamInvites[${i}]`] || {}), email: 'Invalid email address' };
        if (seen.has(r.email.trim().toLowerCase()))
          errors[`teamInvites[${i}]`] = { ...(errors[`teamInvites[${i}]`] || {}), email: 'Duplicate email' };
        seen.add(r.email.trim().toLowerCase());
        if (!r.role)
          errors[`teamInvites[${i}]`] = { ...(errors[`teamInvites[${i}]`] || {}), role: 'Select a role' };
      });
      return { isValid: Object.keys(errors).length === 0, errors };
    }
  },
  {
    key: 'riskModules',
    label: 'Done',
    stepNumber: 5,
    validate: (formData) => {
      const errors = {};
      if (!formData.captchaAnswer?.trim()) {
        errors.captchaAnswer = 'Please type the characters shown in the image';
      } else if (formData.captchaAnswer.trim().toUpperCase() !== formData.captchaExpected) {
        errors.captchaAnswer = 'Characters don\'t match — please try again';
      }
      return { isValid: Object.keys(errors).length === 0, errors };
    }
  }
];

// Helper to get step by key
export const getStepByKey = (key) => SIGNUP_STEPS.find(s => s.key === key);

// Helper to get next step
export const getNextStep = (currentKey) => {
  const currentIndex = SIGNUP_STEPS.findIndex(s => s.key === currentKey);
  return SIGNUP_STEPS[currentIndex + 1] || null;
};

// Helper to get previous step
export const getPreviousStep = (currentKey) => {
  const currentIndex = SIGNUP_STEPS.findIndex(s => s.key === currentKey);
  return SIGNUP_STEPS[currentIndex - 1] || null;
};
